import PropTypes from "prop-types";
import {
  Backdrop,
  CircularProgress,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Select,
  Slider,
} from "@mui/material";
// eslint-disable-next-line import/named
import { geojsons, Region, Countries } from "assets/geojson";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import MenuItem from "@mui/material/MenuItem";
import { useDispatch } from "react-redux";
import Grid2 from "@mui/material/Unstable_Grid2";
import { BUILDIN, CLEAR_ITEMS, DRAW, SET_SUBMIT_CLICKED, SET_SUBMIT_STATUS } from "store/actions";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import { Draw, Snap } from "ol/interaction";
import * as ol from "ol";
import GeoJSON from "ol/format/GeoJSON";
import axios from "axios";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { Feature } from "ol";
import { useNavigate } from "react-router-dom";
// import CloudUploadIcon from "@mui/icons-material/CloudUpload";
// import shp from "shpjs";
import MKBox from "../../components/MKBox";
import MKButton from "../../components/MKButton";
import MKTypography from "../../components/MKTypography";
import GridCard from "../Cards/GridCard";

import clearFlashingFeaturesLayer from "../../utils/clearFlashingFeaturesLayer";
import MKInput from "../../components/MKInput";
// import VisuallyHiddenInput from "../../assets/theme/components/VisuallyHiddenInput";
// import MKAlert from "../../mkcomponents/MKAlert";

const GridCardSelectNewJob = ({ model, map }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Draw是否完毕的状态
  const [DrawStatus, setDrawStatus] = useState(false);

  // 是否正在Draw的状态
  const [DrawingStatus, setDrawingStatus] = useState(false);

  // 判断提交之后的状态
  const [SubmitStatus, setSubmitStatus] = useState(false);

  // Submit提交后台的Geojson
  const [SubmitGeojson, setSubmitGeojson] = useState({});

  // 绘制source、vectorLayer、draw事件、添加Draw和清除Draw
  const source = new VectorSource({ useSpatialIndex: false });
  const geojsonFormat = new GeoJSON();
  const drawVector = new VectorLayer({
    className: "draw",
    zIndex: 1,
    source,
    style: {
      "stroke-color": "rgba(255,51,58,0.84)",
      "stroke-width": 2,
    },
  });
  const draw = new Draw({
    source,
    type: "Polygon",
  });
  draw.on("drawend", (event) => {
    drawVector.getSource().clear();
    const feature = new ol.Feature({
      geometry: event.feature.getGeometry(),
    });
    drawVector.getSource().addFeature(feature);
    // 将Vector图层中的Feature转换为GeoJSON格式
    const geojson = geojsonFormat.writeFeaturesObject(drawVector.getSource().getFeatures());
    setSubmitGeojson(geojson);
    setDrawStatus(true);
    setDrawingStatus(false);
  });
  const snap = new Snap({ source });

  const clearDrawFeature = () => {
    const drawedVector = map
      .getLayers()
      .getArray()
      .find((t) => t.getClassName() === "draw");
    if (drawedVector) {
      map.removeLayer(drawedVector);
    }
    map.getInteractions().removeAt(10);
    map.getInteractions().removeAt(9);
    setDrawStatus(false);
    setDrawingStatus(false);
  };

  const addDrawFeature = () => {
    clearDrawFeature();
    map.getLayers().extend([drawVector]);
    map.addInteraction(draw);
    map.addInteraction(snap);
    setDrawingStatus(true);
  };

  // 选择buildin roi方式时的geojson获取
  const selectedValueRef = useRef(null);
  const [SelectRegionValue, setSelectRegionValue] = useState("");

  const handleMenuItemClick = (e, item) => {
    dispatch({ type: BUILDIN, value: item });
    setSelectRegionValue(item);
    selectedValueRef.current.value = item;
    setSubmitStatus(false);
    dispatch({ type: DRAW, value: false });
  };

  useEffect(() => {
    if (SelectRegionValue !== "") {
      const feature = geojsons.filter((a) => a.name === SelectRegionValue)[0].json;
      const geojson = geojsonFormat.writeFeaturesObject(new GeoJSON().readFeatures(feature));
      setSubmitGeojson(geojson);
    }
  }, [SelectRegionValue]);

  // 选择roi的方式buildin/draw/upload
  const [RoiType, setRoiType] = useState("buildin");
  const cleanOldRoi = () => {
    dispatch({ type: BUILDIN, value: "" });
    clearDrawFeature();
    setSelectRegionValue("");
    setSubmitStatus(false);
  };
  const handleRoiTypeChange = (e) => {
    cleanOldRoi();
    setRoiType(e.target.value);
  };

  // 上传文件
  // const handleFileChange = (event) => {
  //   const file = event.target.files[0];
  //   const extension = file.name.split(".").pop().toLowerCase();
  //   const handleFileRead = (f) =>
  //     new Promise((resolve, reject) => {
  //       const reader = new FileReader();
  //       reader.onload = (e) => {
  //         try {
  //           const geoJson = JSON.parse(e.target.result);
  //           resolve(geoJson);
  //         } catch (error) {
  //           reject(error);
  //         }
  //       };
  //       reader.readAsText(f);
  //     });
  //   // 根据扩展名进行处理
  //   if (extension === "zip") {
  //     const readShpFileZip = (f) =>
  //       new Promise((resolve) => {
  //         const reader = new FileReader();
  //         reader.onload = (e) => {
  //           const buffer = e.target.result; // ArrayBuffer
  //           const result = shp.parseZip(buffer);
  //           resolve(result);
  //         };
  //         reader.readAsArrayBuffer(f);
  //       });
  //     readShpFileZip(file)
  //       .then((r) => {
  //         // Check the projection of the parsed data
  //         if (r && r.features && r.features.length > 0) {
  //           // todo
  //           const firstFeature = r.features[0];
  //           const projection = firstFeature.getGeometry().getProjection().getCode();
  //           if (projection === "EPSG:4326") {
  //             // Projection is EPSG:4326
  //             cleanOldRoi();
  //             setSubmitGeojson(r);
  //             setRoiType("upload");
  //           } else {
  //             MKAlert("Projection is not EPSG:4326");
  //           }
  //         }
  //       })
  //       .catch((error) => {
  //         console.error("Error reading zip", error);
  //       });
  //   } else if (extension === "geojson") {
  //     handleFileRead(file)
  //       .then((r) => {
  //         // Check the projection of the GeoJSON data
  //         if (r) {
  //           // todo
  //           // console.log(r);
  //           // Projection is EPSG:4326
  //           cleanOldRoi();
  //           setSubmitGeojson(r);
  //           setRoiType("upload");
  //         } else {
  //           alert("Projection is not EPSG:4326");
  //         }
  //       })
  //       .catch((error) => {
  //         console.error("Error reading GeoJSON", error);
  //       });
  //   } else {
  //     MKAlert(
  //       "Unsupported file type. Please upload a GeoJSON file or a ZIP file containing .shp .prj .dbf."
  //     );
  //   }
  // };

  // 选择日期
  const { start } = model.available;
  const { end } = model.available;
  const mindate = dayjs(start);
  const maxdate = end !== null ? dayjs(end) : null;

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [endDisabled, setEndDisabled] = useState(true);
  const [endMinDate, setEndMinDate] = useState(null);

  useEffect(() => {
    if (startDate !== null) {
      setEndDisabled(false);
      setEndMinDate(startDate);
    } else {
      setEndDisabled(true);
    }
  }, [startDate]);

  // 其他字段
  const jobType = model.type;
  const [jobName, setJobName] = useState("");

  const [nodesNum, setNodesNum] = useState(5);

  const handleNodesChange = (event) => {
    setNodesNum(event.target.value === "" ? 1 : Number(event.target.value));
    setSubmitStatus(false);
  };
  const handleNodesBlur = () => {
    if (nodesNum < 0) {
      setNodesNum(1);
    } else if (nodesNum > 32) {
      setNodesNum(32);
    }
  };

  const [minTasksPerNode, setMinTasksPerNode] = useState(5);

  const handleMinTasksPerNodeChange = (event) => {
    setMinTasksPerNode(event.target.value === "" ? 5 : Number(event.target.value));
    setSubmitStatus(false);
  };
  const handleMinTasksPerNodeBlur = () => {
    setSubmitStatus(false);
    if (minTasksPerNode < 0) {
      setMinTasksPerNode(5);
    } else if (minTasksPerNode > 100) {
      setMinTasksPerNode(100);
    }
  };

  const [cloudCover, setCloudCover] = useState(20);
  const handleCloudCoverSliderChange = (event, newValue) => {
    setSubmitStatus(false);
    setCloudCover(newValue);
  };
  const handleCloudCoverInputChange = (event) => {
    setSubmitStatus(false);
    setCloudCover(event.target.value === "" ? 0 : Number(event.target.value));
  };
  const handleCloudBlur = () => {
    setSubmitStatus(false);
    if (cloudCover < 0) {
      setCloudCover(0);
    } else if (cloudCover > 100) {
      setCloudCover(100);
    }
  };

  // 判断是否可以提交
  const Prepared = !!(
    !SubmitStatus &&
    (SelectRegionValue !== "" || DrawStatus || RoiType === "upload") &&
    !DrawingStatus &&
    startDate !== null &&
    endDate !== null &&
    jobName !== "" &&
    startDate.isValid() &&
    endDate.isValid()
  );

  // 重置所有选项
  const handleReset = () => {
    clearFlashingFeaturesLayer(map, "flashingFeaturesLayer");
    setSubmitStatus(false);
    setSelectRegionValue("");
    setRoiType("buildin");
    clearDrawFeature();
    dispatch({ type: BUILDIN, value: "" });
    dispatch({ type: DRAW, value: false });
    dispatch({ type: CLEAR_ITEMS });

    setEndDate(null);
    setStartDate(null);

    setJobName("");
    setCloudCover(30);
  };

  const [jobid, setJobid] = useState(" ");
  const [submitBackdrop, setSubmitBackdrop] = useState(false);

  const [respValid, setRespValid] = useState("waiting");

  // 提交动作
  const newJobSubmit = () => {
    dispatch({ type: SET_SUBMIT_CLICKED, value: true });
    if (RoiType !== "draw") {
      map.getInteractions().removeAt(10);
      map.getInteractions().removeAt(9);
      setDrawStatus(false);
      setDrawingStatus(false);
      setSubmitStatus(false);
    } else {
      map.getInteractions().removeAt(10);
      map.getInteractions().removeAt(9);
    }

    dispatch({ type: DRAW, value: RoiType === "draw" });

    clearFlashingFeaturesLayer(map, "flashingFeaturesLayer");
    const geom = new GeoJSON().readFeatures(SubmitGeojson)[0].getGeometry();
    map.getView().fit(geom, {
      padding: [50, 50, 50, 50],
    });
    const geom4326 = geom.transform("EPSG:3857", "EPSG:4326");
    const geoFeature = new Feature({ geometry: geom4326 });

    const geoFeatureCollection = new GeoJSON().writeFeatures([geoFeature]);

    try {
      axios
        .post("https://up9tz2e57j.execute-api.us-west-2.amazonaws.com/default/lucc_api", {
          operation: "submit_job",
          payload: {
            // collections: [model.id],
            start_date: startDate.format("YYYY-MM-DD"),
            end_date: endDate.format("YYYY-MM-DD"),
            cloud_cover: cloudCover,
            scene_task_nodes: nodesNum,
            min_scene_tasks_per_node: minTasksPerNode,
            job_desc: jobType,
            job_name: jobName,
            geojson: JSON.parse(geoFeatureCollection),
          },
        })
        .then((r) => {
          dispatch({ type: SET_SUBMIT_STATUS, value: false });
          // console.log(r);
          setJobid(r.data.job_id);
          dispatch({ type: SET_SUBMIT_STATUS, value: true });
          dispatch({ type: SET_SUBMIT_CLICKED, value: false });
          setSubmitStatus(true);
          setSubmitBackdrop(true);

          const waitingCollection = () => {
            try {
              axios
                .post("https://up9tz2e57j.execute-api.us-west-2.amazonaws.com/default/lucc_api", {
                  operation: "get_job",
                  payload: { job_id: r.data.job_id },
                  with_geom: false,
                })
                .then((response) => {
                  // console.log(response);
                  if (response.data) {
                    setRespValid("success");
                  }
                });
            } catch (error) {
              console.error(error);
            }
          };

          waitingCollection();
        });

      return null;
    } catch (error) {
      console.log(error);
    }

    return null;
  };

  const parentRef = useRef(null);
  const [maxHeight, setMaxHeight] = useState(null);

  useLayoutEffect(() => {
    if (parentRef.current) {
      const parentHeight = parentRef.current.offsetHeight;
      const titleHeight = parentRef.current ? parentRef.current.children[0].offsetHeight : 50;
      setMaxHeight(parentHeight - titleHeight - 48);
    }
  }, [parentRef]);

  const handleBackdropDown = () => {
    setSubmitBackdrop(false);
  };

  const handleViewJob = () => {
    setSubmitBackdrop(false);
    navigate(`/computing/view/${jobid}`);
  };
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={submitBackdrop}
      >
        {respValid === "waiting" ? (
          <Grid2 container item xs={7} justifyContent="center" sx={{ display: "flex" }}>
            <CircularProgress color="white" />
            <MKTypography color="white" variant="h3">
              Submitting job ...
            </MKTypography>
          </Grid2>
        ) : null}
        {respValid === "success" ? (
          <Grid2 container item sx={{ display: "flex", justifyContent: "center" }}>
            <Grid2 justifyContent="center">
              <MKTypography color="white" variant="h4" mb={1}>
                Job submitted.You can view the job details or submit a new job.
              </MKTypography>
            </Grid2>
            <Grid2 container xs={6}>
              <Grid2 xs={6} justifyContent="center" sx={{ display: "flex" }}>
                <MKButton size="large" onClick={handleViewJob} sx={{ mx: 2 }}>
                  View Job
                </MKButton>
              </Grid2>
              <Grid2 xs={6} justifyContent="center" sx={{ display: "flex" }}>
                <MKButton size="large" onClick={handleBackdropDown} sx={{ mx: 2 }}>
                  Another Job
                </MKButton>
              </Grid2>
            </Grid2>
          </Grid2>
        ) : null}
      </Backdrop>
      <GridCard title="Select Data" ref={parentRef}>
        <MKBox maxHeight={maxHeight} sx={{ height: 1, m: { lg: 0.5, xxl: 1, xxxl: 2 } }}>
          {/* 第一部分 region */}
          <Grid2
            container
            item
            xs={12}
            sx={{ my: { lg: 1, xxl: 2, xxxl: 3 }, justifyContent: "center" }}
          >
            <Grid2 xs={8}>
              <RadioGroup value={RoiType} onChange={handleRoiTypeChange}>
                <FormControlLabel value="buildin" control={<Radio />} label="Select a region" />
              </RadioGroup>
            </Grid2>
            <Grid2 xs={8}>
              <Select
                value={SelectRegionValue}
                ref={selectedValueRef}
                fullWidth
                onClick={(event) => {
                  event.stopPropagation();
                }}
                defaultValue=""
                disabled={RoiType !== "buildin"}
              >
                <MenuItem value="" disabled>
                  None
                </MenuItem>
                {Region.map((item) => (
                  <MenuItem
                    key={item}
                    value={item}
                    onClick={(event) => handleMenuItemClick(event, item)}
                  >
                    {item}
                  </MenuItem>
                ))}
                <MenuItem disabled>
                  <MKTypography>Regional Member Countries</MKTypography>
                </MenuItem>
                {Countries.map((item) => (
                  <MenuItem
                    key={item}
                    value={item}
                    onClick={(event) => handleMenuItemClick(event, item)}
                  >
                    {item}
                  </MenuItem>
                ))}
              </Select>
            </Grid2>
            <Grid2 xs={8}>
              <RadioGroup value={RoiType} onChange={handleRoiTypeChange}>
                <FormControlLabel
                  value="draw"
                  control={<Radio />}
                  label="Draw a polygon"
                  sx={{ my: { lg: 1, xxl: 2, xxxl: 3 } }}
                />
              </RadioGroup>
            </Grid2>
            <Grid2 container item xs={8}>
              <Grid2 xs={6} sx={{ display: "flex", justifyContent: "center" }}>
                <MKButton
                  variant="outlined"
                  color="secondary"
                  onClick={addDrawFeature}
                  disabled={DrawStatus || RoiType !== "draw"}
                >
                  Draw
                </MKButton>
              </Grid2>
              <Grid2 xs={6} sx={{ display: "flex", justifyContent: "center" }}>
                <MKButton
                  variant="outlined"
                  color="secondary"
                  onClick={clearDrawFeature}
                  disabled={!DrawStatus || RoiType !== "draw"}
                >
                  Clear
                </MKButton>
              </Grid2>
            </Grid2>
            {/* <Grid2 xs={8} container item> */}
            {/*   <Grid2 xs={6}> */}
            {/*     <MKButton */}
            {/*       component="label" */}
            {/*       variant="contained" */}
            {/*       color="primary" */}
            {/*       startIcon={<CloudUploadIcon />} */}
            {/*       sx={{ m: { lg: 1, xxl: 2, xxxl: 3 } }} */}
            {/*       title="Shapefile zip or GeoJSON file must be projected in EPSG:4326" */}
            {/*     > */}
            {/*       Upload */}
            {/*       <VisuallyHiddenInput type="file" onChange={handleFileChange} /> */}
            {/*     </MKButton> */}
            {/*   </Grid2> */}
            {/*   <Grid2 */}
            {/*     xs={6} */}
            {/*     container */}
            {/*     item */}
            {/*     sx={{ display: "flex", alignItems: "center", alignContent: "center" }} */}
            {/*   > */}
            {/*     <Grid2 xs={12}> */}
            {/*       <MKTypography variant="body1">File Name</MKTypography> */}
            {/*     </Grid2> */}
            {/*     <Grid2 xs={12}> */}
            {/*       <MKTypography color="info" variant="body1"> */}
            {/*         Upload Status */}
            {/*       </MKTypography> */}
            {/*     </Grid2> */}
            {/*   </Grid2> */}
            {/* </Grid2> */}
            <Grid2 container item xs={8} />
          </Grid2>
          {/* 第二部分 起始终止日期 */}
          <Grid2
            container
            xs={12}
            sx={{ my: { lg: 1, xxl: 2, xxxl: 3 }, justifyContent: "center" }}
          >
            <Grid2 item xs={8}>
              <FormLabel id="multipe-select-year-label" required>
                Select Start/End Date
              </FormLabel>
            </Grid2>
            <Grid2 item xs={8} mb={1}>
              <DatePicker
                sx={{ width: 1 }}
                value={startDate}
                minDate={mindate}
                maxDate={maxdate}
                {...(maxdate === null ? { disableFuture: true } : {})}
                onChange={(newValue) => setStartDate(newValue)}
              />
            </Grid2>
            <Grid2 xs={8}>
              <DatePicker
                sx={{ width: 1 }}
                value={endDate}
                minDate={endMinDate !== null ? endMinDate : mindate}
                {...(maxdate === null ? { disableFuture: true } : {})}
                maxDate={maxdate}
                disabled={endDisabled}
                onChange={(newValue) => setEndDate(newValue)}
              />
            </Grid2>
          </Grid2>
          {/* 第三部分 其他 */}
          <Grid2
            container
            xs={12}
            sx={{ my: { lg: 1, xxl: 2, xxxl: 3 }, justifyContent: "center" }}
          >
            <Grid2 item xs={8}>
              <FormLabel id="other-values" required>
                Job Name
              </FormLabel>
            </Grid2>
            <Grid2 item xs={8}>
              <MKInput
                fullWidth
                value={jobName}
                size="small"
                onChange={(e) => {
                  setJobName(e.target.value);
                }}
              />
            </Grid2>

            <Grid2 container xs={8} sx={{ mt: { lg: 1, xxl: 2, xxxl: 3 } }}>
              <Grid2
                container
                xs={6}
                sx={{ justifyContent: "center", display: "flex", pr: 1, alignItems: "center" }}
              >
                <Grid2 xs={8}>
                  <FormLabel id="other-values">GPU Nodes</FormLabel>
                </Grid2>
                <Grid2 xs={4}>
                  <MKInput
                    value={nodesNum}
                    size="small"
                    onChange={handleNodesChange}
                    onBlur={handleNodesBlur}
                    inputProps={{
                      step: 1,
                      min: 1,
                      max: 32,
                      type: "number",
                      "aria-labelledby": "input-slider",
                    }}
                  />
                </Grid2>
              </Grid2>
              <Grid2
                container
                xs={6}
                sx={{ justifyContent: "center", display: "flex", alignItems: "center", pl: 1 }}
              >
                <Grid2 xs={8}>
                  <FormLabel id="other-values">Tasks per GPU node</FormLabel>
                </Grid2>
                <Grid2 xs={4}>
                  <MKInput
                    value={minTasksPerNode}
                    size="small"
                    onChange={handleMinTasksPerNodeChange}
                    onBlur={handleMinTasksPerNodeBlur}
                    inputProps={{
                      step: 1,
                      min: 5,
                      max: 100,
                      type: "number",
                      "aria-labelledby": "input-slider",
                    }}
                  />
                </Grid2>
              </Grid2>
            </Grid2>
          </Grid2>
          <Grid2
            container
            xs={12}
            sx={{ my: { lg: 1, xxl: 2, xxxl: 3 }, justifyContent: "center" }}
          >
            <Grid2 xs={8}>
              <MKTypography id="input-slider" gutterBottom>
                Cloud Cover
              </MKTypography>
            </Grid2>
            <Grid2 container item xs={8} spacing={2} alignItems="center">
              <Grid2 item xs={3}>
                <MKInput
                  sx={{ width: "50px" }}
                  value={cloudCover}
                  size="small"
                  onChange={handleCloudCoverInputChange}
                  onBlur={handleCloudBlur}
                  inputProps={{
                    step: 10,
                    min: 0,
                    max: 100,
                    type: "number",
                    "aria-labelledby": "input-slider",
                  }}
                />
              </Grid2>
              <Grid2 item xs={9}>
                <Slider
                  value={typeof cloudCover === "number" ? cloudCover : 0}
                  onChange={handleCloudCoverSliderChange}
                  aria-labelledby="input-slider"
                />
              </Grid2>
            </Grid2>
          </Grid2>
          {/* 第四部分 提交、重置按钮 */}
          <Grid2
            container
            xs={12}
            sx={{ my: { lg: 1, xxl: 2, xxxl: 3 }, justifyContent: "center" }}
          >
            <Grid2 container item xs={8} mt={1}>
              <Grid2 xs={6} sx={{ display: "flex", justifyContent: "center" }}>
                <MKButton
                  variant="contained"
                  color="secondary"
                  component="a"
                  disabled={!Prepared}
                  onClick={() => {
                    newJobSubmit();
                    setSubmitBackdrop(true);
                  }}
                >
                  Submit
                </MKButton>
              </Grid2>
              <Grid2 xs={6} sx={{ display: "flex", justifyContent: "center" }}>
                <MKButton
                  variant="contained"
                  color="secondary"
                  component="a"
                  disabled={!SubmitStatus}
                  onClick={handleReset}
                >
                  RESET
                </MKButton>
              </Grid2>
            </Grid2>
          </Grid2>
        </MKBox>
      </GridCard>
    </LocalizationProvider>
  );
};

GridCardSelectNewJob.defaultProps = {
  model: {},
  map: undefined,
};

GridCardSelectNewJob.propTypes = {
  model: PropTypes.objectOf(PropTypes.any),
  map: PropTypes.oneOfType([PropTypes.any]),
};
export default GridCardSelectNewJob;
